export const services = [
  {
    id: 1,
    title: "Design & Engineering",
    description: "Custom HVAC system design tailored to your space. Our team analyzes your requirements to create optimal cooling solutions with precise load calculations.",
    icon: "lightbulb"
  },
  {
    id: 2,
    title: "End-to-End Implementation",
    description: "Complete project management from design to commissioning. Professional execution ensuring timely delivery and quality.",
    icon: "wrench"
  },
  {
    id: 3,
    title: "HVAC Consultation",
    description: "Expert guidance on HVAC system selection, capacity planning, and technology upgrades. Technical expertise to solve complex cooling challenges.",
    icon: "settings"
  },
  {
    id: 4,
    title: "Energy Consultation",
    description: "Energy efficiency and optimization strategies. Reduce operational costs while maintaining optimal comfort with data-driven recommendations.",
    icon: "tool"
  },
  {
    id: 5,
    title: "Residential Projects",
    description: "Luxury homes to apartment complexes - complete cooling solutions. Custom designs that blend seamlessly with your interior aesthetics.",
    icon: "home"
  },
  {
    id: 6,
    title: "Commercial Projects",
    description: "Office buildings, retail spaces, and industrial facilities. Scalable HVAC solutions with professional project management and support.",
    icon: "building"
  }
];

export const clients = [
  { id: 1, name: 'Tata Consultancy Services' },
  { id: 2, name: 'Reliance Industries' },
  { id: 3, name: 'Tata International' },
  { id: 4, name: 'GE Capital' },
  { id: 5, name: 'Ericsson India' },
  { id: 6, name: 'SRF Limited' },
  { id: 7, name: 'DCM Shriram' },
  { id: 8, name: 'Dalmia Bharat Cement' },
  { id: 9, name: 'Somany Tiles' },
  { id: 10, name: 'Pantaloon Retail' },
  { id: 11, name: 'Jay Bharat Maruti' },
  { id: 12, name: 'Orient Craft' },
];

// Real projects from the company profile, described by the TYPE OF SPACE only.
// Never put a project, client or government body name here. Order = display
// order. Images are illustrations (the section says so); the work is real.
export const projects = [
  {
    id: 1,
    title: 'Luxury residences',
    location: 'South Delhi',
    image: '/media/projects/luxury-residences.webp',
    description: 'VRV for premium homes in Defence Colony, Gulmohar Park and Vasant Vihar'
  },
  {
    id: 2,
    title: 'Government buildings',
    location: 'New Delhi',
    image: '/media/projects/government-buildings.webp',
    description: 'VRV for an office and auditorium complex, over 1,000 TR, with the maintenance contract held since 2000'
  },
  {
    id: 3,
    title: 'Commercial buildings',
    location: 'Gurugram',
    image: '/media/projects/commercial-buildings.webp',
    description: 'VRV for four commercial buildings in Sector 43, Udyog Vihar and DLF Phase III'
  },
  {
    id: 4,
    title: 'Co-working spaces',
    location: 'Okhla and Gurugram',
    image: '/media/projects/co-working.webp',
    description: 'Three co-working centres, each on its own VRV system'
  },
  {
    id: 5,
    title: 'Showrooms',
    location: 'New Delhi and Noida',
    image: '/media/projects/showrooms.webp',
    description: 'VRV air conditioning for a chain of showrooms at multiple locations'
  },
  {
    id: 6,
    title: 'Factories',
    location: 'Modinagar and Delhi',
    image: '/media/projects/factories.webp',
    description: 'A manufacturing group\'s factory and offices'
  },
  {
    id: 7,
    title: 'Banking and data centres',
    location: 'New Delhi',
    image: '/media/projects/banking-data-centres.webp',
    description: 'A bank\'s head office, data centre and branches, with the maintenance contract held since 1996'
  },
  {
    id: 8,
    title: 'Mass housing',
    location: 'New Delhi',
    image: '/media/projects/mass-housing.webp',
    description: '1,320 split ACs installed in 15 days across a 2,304-home housing project'
  },
];

export const awards = [
  {
    id: 1,
    title: "#1 HVAC Dealer",
    year: "North region",
    organization: "Daikin India & Carrier Aircon",
    icon: "trophy",
    image: "/media/5zc2vye0-image.webp"
  },
  {
    id: 2,
    title: "MD Club",
    year: "Gold Member",
    organization: "Daikin India",
    icon: "award",
    image: "/media/if597xap-gold-club.webp"
  },
  {
    id: 3,
    title: "Quality Effort Award",
    year: "Customer Satisfaction",
    organization: "Daikin India",
    icon: "star",
    image: "/media/s7ga9kwd-quality-effort.webp"
  },
  {
    id: 4,
    title: "First Position for Sales",
    year: "Delhi region",
    organization: "Daikin India",
    icon: "trophy",
    image: "/media/jtnn29c6-delhi-region.webp"
  },
  {
    id: 101,
    title: "Authorised Daikin Solution Plaza",
    organization: "Daikin India, reserved for select premium partners",
    year: "",
    image: "",
    icon: "award"
  },
  {
    id: 102,
    title: "Highest Sales Dealer, North India",
    organization: "Carrier Aircon",
    year: "",
    image: "",
    icon: "trophy"
  },
  {
    id: 103,
    title: "Best Service Dealer, North India",
    organization: "Carrier Aircon",
    year: "",
    image: "",
    icon: "trophy"
  }
];

export const team = [
  {
    id: 1,
    name: "Hemant Sareen",
    role: "Founder & Managing Director",
    description: "35+ years in HVAC engineering with expertise in complex commercial, resedential and large scale installations",
    image: "/media/p3yqcz6s-chatgpt-image-feb-26-2026-12-41-22-pm.webp"
  },
  {
    id: 2,
    name: "Saheb Sareen",
    role: "Director - Operations & Strategy",
    description: "Big 4 management consulting background, ensuring professional project delivery and client satisfaction",
    image: "/media/hjgs5aq5-image.webp",
    linkedin: "https://www.linkedin.com/in/sahebsareen/"
  }
];

export const stats = [
  {
    id: 1,
    value: "1500+",
    label: "Projects Completed"
  },
  {
    id: 2,
    value: "35+",
    label: "Years Experience"
  },
  {
    id: 3,
    value: "50,000+",
    label: "Tonnes Installed"
  },
  {
    id: 4,
    value: "50%+",
    label: "Energy Savings"
  }
];
